import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

import { Education } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';

@Component({
  selector: 'app-add-education',
  templateUrl: './add-education.component.html',
  styleUrls: ['./add-education.component.css']
})
export class AddEducationComponent {
  public options = {type : 'address', componentRestrictions: {}};
  public educations = [] as Array<Education>;
  public newEdu = {
    start_month: null,
    start_year: null,
    end_month: null,
    end_year: null
  } as Education;
  public addMore = true;
  public descs = [
    '<div class="titleAdd__body">Overview the processes of the company functioning</div>',
    '<div class="titleAdd__body">Enterprise grade machine learning platform for auto-updating while the grade machine learning platform for auto-updating. Enterprise grade machine learning platform for auto-updating.</div>',
    '<div class="titleAdd__body">Enterprise grade machine learning platform for auto-updating. Enterprise grade machine learning platform for auto-updating.</div>',
    '<div class="titleAdd__body">Overview the processes of the company functioning</div>',
    '<div class="titleAdd__body">Enterprise grade machine learning platform for auto-updating. Enterprise grade machine learning platform for auto-updating.</div>',
    '<div class="titleAdd__body">Implemented multiple predictive models and clustering to cross-sell high profit LAP (loan against property) to current clients. </div>'
  ];
  public months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public theme_id;
  constructor(
    private router: Router,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService
  ) {
    const resume_id = this.localStorageService.get('resume_id') as string;
    this.newEdu.resume_id = resume_id;
    this.resumeService.getResumeById(resume_id).subscribe(res => {
      this.educations = res.Education || [];
      if (this.educations.length > 0) {
        this.addMore = false;
      }
    });
    this.theme_id = this.localStorageService.get('theme_id') as string || 1;
  }
  handleAddressChange(address: Address, model: Education) {
    model.college = address.name;
    model.address = address.vicinity;
  }
  edit(edu) {
    this.resumeService.updateEducation(edu).subscribe(res => {
      const theme_id = this.localStorageService.get('theme_id') as string || 1;
      this.router.navigate(['/themes/' + theme_id]);
      edu.edit = false;
      edu = res;
    });
  }
  add() {
    const resume_id = this.localStorageService.get('resume_id') as string;
    this.newEdu.resume_id = resume_id;
    this.resumeService.updateEducation(this.newEdu).subscribe(res => {
      this.educations.unshift(res.education);
      this.router.navigate(['/resume/exp']);
    }, err => {
      console.log(err);
    });
  }
  remove(edu) {
    edu.delete = 1;
    this.resumeService.updateEducation(edu).subscribe(res => {
      const index = this.educations.lastIndexOf(edu);
      this.educations.splice(index, 1);
    });
  }
  next() {
    this.router.navigate(['/resume/exp']);
  }
  appendDescription(model, html) {
    model.description += html;
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }
}
